module.exports = __webpack_public_path__ + "assets/3d50421e8437059e57d7d1babd7482c0.png";